export default __webpack_public_path__ + "static/media/H0005.c2a1f9af.png";